import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import MessageCreateSF from './MessageCreateSF'
import MessageUpdateSF from './MessageUpdateSF'
import './MessageList.css'

const MessageListUI = ({context, messageList, taskMessageList, messageUserList, projectUserMap, projectUserList, project, task,
    scrollToBottom, onMessageListUpdate, onForceTaskListRefresh, onForceTaskMessageListRefresh
  }) =>
  <div className='c_tsk_msgs'>
    {
      (!taskMessageList || !messageUserList) &&
      <SpinnerComponentUI />
    }
    {
      messageUserList && taskMessageList && taskMessageList.length === 0 &&
      <MessageUI messageList={messageList} messageKey='c_no_comments' />
    }
    {
      messageUserList && taskMessageList && taskMessageList.map((message, i) =>
        <MessageUpdateSF
          key={i}
          context={context}
          messageList={messageList}
          taskMessageList={taskMessageList}
          messageUserList={messageUserList}
          onMessageListUpdate={onMessageListUpdate}
          onForceTaskListRefresh={onForceTaskListRefresh}
          onForceTaskMessageListRefresh={onForceTaskMessageListRefresh}
          projectUserList={projectUserList}
          projectUserMap={projectUserMap}
          message={message}
          project={project}
          task={task}
        />
      )
    }
    <div className='g_m_top_100' />
    {
      messageUserList && taskMessageList && project.permissionList.includes('prj_participate') &&
      <MessageCreateSF
        context={context}
        messageList={messageList}
        taskMessageList={taskMessageList}
        messageUserList={messageUserList}
        onMessageListUpdate={onMessageListUpdate}
        onForceTaskListRefresh={onForceTaskListRefresh}
        projectUserList={projectUserList}
        task={task}
      />
    }
  </div>

export default MessageListUI
